import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged, updateProfile } from "firebase/auth"
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { useState, useEffect } from "react";


const firebaseConfig = {
  apiKey: "AIzaSyCWDJs1suMelfwhETO3FouhmZzfvvkHkgU",
  authDomain: "react-mountains.firebaseapp.com",
  projectId: "react-mountains",
  storageBucket: "gs://react-mountains.appspot.com/",
  messagingSenderId: "118024313478",
  appId: "1:118024313478:web:714f82414be013851f8f07",
};

const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);


export const auth = getAuth(app)

export function useAuth() {
  const [currentUser, setCurrentUser] = useState();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, user => setCurrentUser(user));
    return unsub;
  }, [])

  return currentUser;
}

export async function upload(file, currentUser, setLoading) {
  const fileRef = ref(storage, currentUser.uid + '.png');

  setLoading(true);
  
  const snapshot = await uploadBytes(fileRef, file);
  const photoURL = await getDownloadURL(fileRef);

  updateProfile(currentUser, {photoURL}, {snapshot});
  
  setLoading(false);
  alert("Profilový obrázek byl nahrán!");
  window.location.reload();
;}